import { Pipe, PipeTransform } from '@angular/core';
import { ComponentWithConfigsObject } from '../../../../configuration/componentsWithConfigs.datamodel';
import { ConfigurationService } from '../../../../configuration/store/configuration.service';
import { FunctionalParametersObject } from '../../../../publish/component/form/smartscript/smartScript.datamodel';
import { ParameterContentValue, ParameterObject } from '../configuration-parameters/parameters-group/parameters.model';
import { ContentModel } from '../../../../publish/component/store/component.datamodel';

/**
 * Returns the aggregated content of the selected organization for a given component and if it's a valid JSON format.
 * Additionally returns the template for parameter configurations
 */
@Pipe({
    name: 'getSelectedConfiguration',
    standalone: false
})
export class GetSelectedConfigurationPipe implements PipeTransform {
  constructor(private readonly configurationService: ConfigurationService) {
  }
  transform(component: ComponentWithConfigsObject, configurations: any): ParameterContentValue {
    const configId = (configurations)[component.component.id];
    const template = GetSelectedConfigurationPipe.getComponentTemplate(component.component.content);
    return {...this.configurationService.getAggregatedConfiguration(component, configId), template};
  }

  private static getComponentTemplate(content: ContentModel): ParameterObject | undefined {
    return content instanceof FunctionalParametersObject ? GetSelectedConfigurationPipe.buildTemplate(content) : undefined;
  }

  private static buildTemplate(content: FunctionalParametersObject): ParameterObject {
    return content.parameterDefinitions.reduce((template, parameter) => {
      const {name, ...rest} = parameter;
      return {...template, [name!]: {...rest}};
    }, {});
  }
}
